<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span>For Sherina:</span></p>
<p class="ded1"><span>Spring so early</span></p>
<p class="ded1"><span>swallows are a dream</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?8fd1706c